/* eslint-disable import/prefer-default-export */
export const matrix = [
  {
    label: '<179',
    value: 179,
    min: 1,
    max: 179,
  },
  {
    label: '180-269',
    value: 180,
    min: 180,
    max: 269,
  }, {
    label: '270-369',
    value: 270,
    min: 270,
    max: 369,
  },
  {
    label: '370-469',
    value: 370,
    min: 370,
    max: 469,
  }, {
    label: '470-569',
    value: 470,
    min: 470,
    max: 569,
  }, {
    label: '570-669',
    value: 570,
    min: 570,
    max: 669,
  }, {
    label: '670-769',
    value: 670,
    min: 670,
    max: 769,
  }, {
    label: '770-869',
    value: 770,
    min: 770,
    max: 869,
  }, {
    label: '870-969',
    value: 870,
    min: 870,
    max: 969,
  }, {
    label: '970-1169',
    value: 970,
    min: 970,
    max: 1169,
  }, {
    label: '1170-1469',
    value: 1170,
    min: 1170,
    max: 1469,
  }, {
    label: '1470-1899',
    value: 1470,
    min: 1470,
    max: 1899,
  }, {
    label: '1900-2399',
    value: 1900,
    min: 1900,
    max: 2399,
  }, {
    label: '2400-2899',
    value: 2400,
    min: 2400,
    max: 2899,
  }, {
    label: '2900-3899',
    value: 2900,
    min: 2900,
    max: 3899,
  }, {
    label: '3900-4799',
    value: 3900,
    min: 3900,
    max: 4799,
  }, {
    label: '4800+',
    value: 4800,
    min: 4800,
    max: 10000,
  }];

  // <125, 126-189, 190-270, 279-379, 380-579, 580+
export const officeMatrix = [
  {
    label: '<125',
    value: 125,
    min: 1,
    max: 125,
  },
  {
    label: '126-189',
    value: 189,
    min: 126,
    max: 189,
  }, {
    label: '190-279',
    value: 279,
    min: 190,
    max: 279,
  },
  {
    label: '280-379',
    value: 379,
    min: 280,
    max: 379,
  }, {
    label: '380-579',
    value: 579,
    min: 380,
    max: 579,
  }, {
    label: '570-769',
    value: 570,
    min: 570,
    max: 769,
  }, {
    label: '770+',
    value: 770,
    min: 770,
    max: 10000,
  },
];

export const getMatrixValue = (value, type = 'Warehouse') => {
  switch (type) {
    case 'Warehouse': {
      const foundMatrix = matrix.filter(item => (item.value === value));
      return foundMatrix.length ? foundMatrix[0].label : '';
    }
    default: {
      const foundMatrix = officeMatrix.filter(item => (item.value === value));
      return foundMatrix.length ? foundMatrix[0].label : '';
    }
  }
};

export const setMatrixValueBasedOnTheSize = (value, type = 'Warehouse') => {
  switch (type) {
    case 'Warehouse': {
      const foundMatrix = matrix.filter(item => (item.min <= value && item.max >= value));
      return foundMatrix.length ? foundMatrix[0].value : '';
    }
    case 'Office': {
      const foundMatrix = officeMatrix.filter(item => (item.min <= value && item.max >= value));
      return foundMatrix.length ? foundMatrix[0].value : '';
    }
    default: {
      return '';
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/sizeMatrix.js